import { useEffect, useState } from 'react';
import { PopTownLogo } from './Brand';
import { TownScene } from '../views/login/TownScene';
import { useTownMotion } from '../views/login/townMotion';

const RETRY_MS = 5000;

// Schermata «Aggiornamento in corso»: stessa scena del login (tela, artboard 12). Riprova ogni
// 5 secondi l'endpoint più leggero e, appena risponde, ricarica la pagina sulla versione nuova.
export function UpdatingScreen({ probe }: { probe: string }) {
  const [motion] = useTownMotion();
  const [tries, setTries] = useState(0);

  useEffect(() => {
    const t = window.setInterval(async () => {
      try {
        const r = await fetch(probe, { credentials: 'same-origin', cache: 'no-store' });
        if (r.ok) window.location.reload();
      } catch {
        /* ancora giù */
      }
      setTries((n) => n + 1);
    }, RETRY_MS);
    return () => window.clearInterval(t);
  }, [probe]);

  return (
    <div
      role="alert"
      aria-live="polite"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1000,
        display: 'grid',
        placeItems: 'center',
        padding: 24,
        background: 'var(--bg)',
        overflow: 'hidden',
      }}
    >
      <TownScene motion={motion} />
      <div
        className="login-card"
        style={{
          position: 'relative',
          width: 380,
          maxWidth: '100%',
          background: 'var(--panel)',
          border: '1px solid var(--border)',
          borderRadius: 'var(--r-2xl)',
          boxShadow: 'var(--shadow-2)',
          padding: 28,
          textAlign: 'center',
        }}
      >
        <div style={{ display: 'grid', placeItems: 'center', marginBottom: 14 }}>
          <PopTownLogo height={88} />
        </div>
        <h1 className="t-h1" style={{ letterSpacing: '-0.01em' }}>
          Aggiornamento in corso
        </h1>
        <div className="t-small dim" style={{ marginTop: 8 }}>
          PopTown si sta aggiornando. La pagina torna da sola appena la versione nuova risponde.
        </div>
        <div className="t-caption faint" style={{ marginTop: 16 }}>
          {tries === 0 ? 'Riprovo fra 5 secondi' : `Tentativo ${tries} · riprovo ogni 5 secondi`}
        </div>
      </div>
    </div>
  );
}
